import { useCallback } from 'react';
import { LabelValue } from 'graphql/types';
import { WbsTaskSearchResult } from 'graphql/types';
import { DependantLabels } from '../schema';

export const useTaskOnSelect = (
  onSelect: (value: LabelValue | null) => void,
  dependentLabels: DependantLabels,
  onClose: () => void
): ((value?: WbsTaskSearchResult | null) => void) => {
  const useTaskOnSelect = useCallback(
    async (value?: WbsTaskSearchResult | null) => {
      const stringValue = value?.parents
        .map(({ displayText }) => displayText)
        .concat(value.displayText)
        .join(' / ');

      const transformedValue = {
        idValue: value?.id,
        numericValue: null,
        stringValue: stringValue
      };

      onSelect(value ? transformedValue : null);
      onClose();
    },
    [onClose, onSelect]
  );

  return useTaskOnSelect;
};

export default useTaskOnSelect;
